import type { ConceptDef } from '../types';

export const intraverbalWh: ConceptDef = {
  kind: 'tileMatch',
  id: 'intraverbal-wh',
  label: 'Intraverbal Wh-Questions',
  category: 'Intraverbal',
  description: 'Hear a Wh-question; tap the answer.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'What flies?', answer: '🐦 bird' },
      { say: 'What barks?', answer: '🐶 dog' },
      { say: 'What swims?', answer: '🐟 fish' },
      { say: 'What buzzes?', answer: '🐝 bee' },
      { say: 'What roars?', answer: '🦁 lion' },
      { say: 'What hops?', answer: '🐸 frog' },
    ],
  },
};
